const contact_types = [
  { key: 1, value: 1, text: "tylko e-mail" },
  { key: 2, value: 2, text: "tylko telefon" }, // edycja wymagana też w .api 
  { key: 3, value: 3, text: "telefon oraz e-mail" }
];

export default  contact_types;